import { getRandomUserColor } from "../constants/colors.js";

export const generateUserId = (): string => {
  return `user_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};

export const generateUserName = (): string => {
  const adjectives = [
    "Anonymous",
    "Curious",
    "Creative",
    "Brilliant",
    "Focused",
    "Energetic",
    "Thoughtful",
    "Innovative",
  ];
  const nouns = ["Writer", "Editor", "Collaborator", "Contributor", "Author", "User"];

  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 1000);

  return `${adjective} ${noun} ${number}`;
};

export const createRandomUser = () => {
  return {
    id: generateUserId(),
    name: generateUserName(),
    color: getRandomUserColor(),
  };
};
